module.exports = __webpack_public_path__ + "img/il_Onboarding_resources.77793044.svg";